import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

export interface DropboxStatus {
  connected: boolean;
  email: string;
  display_name: string;
  root_path: string;
}

export const dropboxApiClient = createApi({
  reducerPath: 'dropboxApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['DropboxStatus'],
  endpoints: (builder) => ({
    getDropboxStatus: builder.query<DropboxStatus, { firmId: string }>({
      query: ({ firmId }) =>
        `api/integrations/dropbox/status?firm_id=${firmId}`,
      providesTags: (_result, _error, { firmId }) => [
        { type: 'DropboxStatus', id: firmId },
      ],
    }),
    disconnectDropbox: builder.mutation<{ message: string }, { firmId: string }>(
      {
        query: ({ firmId }) => ({
          url: `api/integrations/dropbox/disconnect?firm_id=${firmId}`,
          method: 'POST',
        }),
        invalidatesTags: (_result, _error, { firmId }) => [
          { type: 'DropboxStatus', id: firmId },
        ],
      },
    ),
    updateDropboxRootPath: builder.mutation<
      { message: string; root_path: string },
      { firmId: string; rootPath: string }
    >({
      query: ({ firmId, rootPath }) => ({
        url: `api/integrations/dropbox/root-path?firm_id=${firmId}`,
        method: 'PATCH',
        body: { root_path: rootPath },
      }),
      invalidatesTags: (_result, _error, { firmId }) => [
        { type: 'DropboxStatus', id: firmId },
      ],
    }),
  }),
});

export const {
  useGetDropboxStatusQuery,
  useDisconnectDropboxMutation,
  useUpdateDropboxRootPathMutation,
} = dropboxApiClient;
